<template>
  <div class="automation">
    <div style="margin-bottom: 10px">
      <el-button style="float: left" @click="goBack" type="primary"
        ><i class="fas fa-arrow-left"></i> Go Back</el-button
      ><el-button
        style="float: right"
        @click="action('edit', 'new')"
        type="primary"
        >+ Add new Email Template</el-button
      >
    </div>
    <div style="clear: both"></div>
    <hr style="margin-top: 10px" />
  </div>
</template>
<script>
import ApiService from "@/services/ApiService";
export default {
  name: "RawMailgunTemplates",
  data() {
    return {
      data: [],
    };
  },
  methods: {
    goBack() {
      this.$router.push("/members/automations");
    },
    getTemplates() {
      ApiService.automationsApi.getRawMailgunTemplates().then((resp) => {
        this.data = resp.data;
      });
    },
  },
  mounted() {
    this.getTemplates();
  },
};
</script>
